import React, { useState, useEffect } from "react";
import { Select } from "antd";
import "./index.module.scss";

const { Option } = Select;

interface DropdownOption {
  value: string;
  label: string;
}

interface DropdownProps {
  options?: DropdownOption[];
  placeholder?: string;
  value: string[];
  onChange?: (selected: string[]) => void;
  isLoading?: boolean; // Add this prop
}

const DropdownComponent: React.FC<DropdownProps> = ({
  options = [],
  placeholder = "Select options",
  value = [],
  onChange,
  isLoading = false, // Default to false
}) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>(value);

  // Sync with parent value
  useEffect(() => {
    setSelectedOptions(value);
  }, [value]);

  // const getPlaceholder = (): string => {
  //   const count = selectedOptions.includes("all")
  //     ? options.length - 1  // Exclude 'all' from count
  //     : selectedOptions.length;
  //   return count === 0 ? placeholder : `${count} selected`;
  // };

  const handleSelectChange = (newValues: string[]) => {
    const hasAll = newValues.includes("all");
    const previousHasAll = selectedOptions.includes("all");

    if (hasAll && !previousHasAll) {
      // Selected "All" - select everything including "all" once
      let updatedSelection;
      if (options.length > 1) {
        updatedSelection = [
          ...options
            .filter((opt) => opt.value !== "all")
            .map((opt) => opt.value),
        ];
      } else {
        updatedSelection = [
          "all",
          ...options
            .filter((opt) => opt.value !== "all")
            .map((opt) => opt.value),
        ];
      }
      setSelectedOptions(updatedSelection);
      onChange?.(updatedSelection);
    } else if (!hasAll && previousHasAll) {
      // Deselected "All" - clear all selections and trigger reload
      setSelectedOptions([]);
      onChange?.([]);
    } else {
      setSelectedOptions(newValues);
      onChange?.(newValues);
    }
  };

  const handleDeselect = (deselectedValue: string) => {
    if (deselectedValue === "all") {
      // When "all" is deselected, clear everything
      setSelectedOptions([]);
      onChange?.([]);
    } else {
      const next = selectedOptions.filter((v) => v !== deselectedValue);
      setSelectedOptions(next);
      onChange?.(next);
    }
  };

  const handleDropdownVisibleChange = (open: boolean) => {
    if (!open && selectedOptions.length > 0) {
      // Keep "all" in selections if present
      onChange?.(selectedOptions);
    }
  };

  return (
    <div className="dropdown-container">
      <Select
        mode="multiple"
        value={selectedOptions}
        onChange={handleSelectChange}
        onDeselect={handleDeselect}
        style={{ width: "100%" }}
        placeholder={selectedOptions.length === 0 ? placeholder : ""}
        // suffixIcon={
        //   selectedOptions.length > 0 ? (
        //     <span className="selection-count">{getPlaceholder()}</span>
        //   ) : null
        // }
        onDropdownVisibleChange={handleDropdownVisibleChange}
        maxTagCount="responsive"
        disabled={isLoading || options.length === 1} // Add this prop
        loading={isLoading} // Add this prop
      >
        {options.map((option) => (
          <Option
            key={option.value}
            value={option.value}
            className={option.value === "all" ? "select-all-option" : ""}
          >
            {option.label}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default DropdownComponent;
